import { createUseSfyr } from '@epihub/core/src/stringifyr/react/createUseSfyr';
import { useSyncExternalStore } from 'react';
import { sfyr } from '@krishanmadan/core/src/_ctx/sfyr';

export const useSfyr = createUseSfyr(sfyr, {
  React: {
    useSyncExternalStore,
  },
});
